// removed by extract-text-webpack-plugin
module.exports = {"socialLinks":"_2WkalZ6","socialLink":"_1gagYVR","Facebook":"i8FxB9X","Instagram":"EOORuiO","Snapchat":"uQdwP38","Vk":"_2mLsYUT"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Footer/SocialLinks/index.css
// module id = ./template/components/Footer/SocialLinks/index.css
// module chunks = client.sitechrome